import { getCopilotChatUserId } from "@services/copilotService";

export const getCopilotUrl = async (): Promise<string | null> => {
  try {
    const chatUserId = await getCopilotChatUserId();
    
    if (!chatUserId) {
      console.warn("Could not get chat user ID for copilot");
      return null;
    }

    return `${process.env.NEXT_PUBLIC_FRONTEND_HOST}/p/acko-assist-v2/chat?journey=acko-drive&chatUserId=${chatUserId}`;
  } catch (error: any) {
    console.error("Error generating copilot URL", error.message);
    return null;
  }
};
